import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

// Sentry is enabled only when VITE_SENTRY_DSN is provided at build time.
// Without it the SDK stays inert and the app behaves exactly as before.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ||
      (import.meta.env.PROD ? "production" : "development"),
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
  });
}

function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#02050A",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        textAlign: "center",
        padding: 24,
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div style={{ fontSize: 22, fontWeight: 700, color: "#00F0FF" }}>
        Что-то пошло не так
      </div>
      <div style={{ maxWidth: 420, color: "rgba(255,255,255,0.7)", lineHeight: 1.5 }}>
        Произошла непредвиденная ошибка. Мы уже уведомлены. Попробуйте обновить
        страницу.
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: 8,
          padding: "10px 20px",
          background: "#00F0FF",
          color: "#02050A",
          border: "none",
          borderRadius: 10,
          fontSize: 15,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Обновить страницу
      </button>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
